import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React from "react";

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
}));

type Props = {
    open : boolean;
    onClose : () => void;
    description : string;
    startTime : string;
    handelUnsubmit : () => Promise<void>;
    isInvoiced : boolean;
};

const UnSubmitDialog : React.FC<Props> = ({open, onClose, description, startTime, handelUnsubmit, isInvoiced} : Props) =>{
    const classes = useStyles();

    return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle disableTypography>
            <Typography variant="h6">Submitted Time Entry</Typography>
            <IconButton className={classes.closeButton} onClick={onClose} airia-label="close">
                <CloseIcon/>
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <Typography paragraph>{description}</Typography>
            <Typography paragraph>{isInvoiced
                ? 'This time entry record is invoiced so it cannot be changed.'
                : 'You can unsubmit this time entry record if you need to make changes.'}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Grid container>
                <Grid>
                    <Button onClick={onClose}>
                        Ok
                    </Button>
                </Grid>
                <Grid item xs={true}/>
                <Grid>
                    {!isInvoiced 
                    && <Button color="primary" onClick={handelUnsubmit}>
                        Unsubmit
                    </Button>}
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>;
}

export default UnSubmitDialog;